<div fxLayout="column" fxLayoutGap="10px">
  <mat-card appearance="outlined" fxFlex="100" fxLayout="row">
    <mat-card-title>
      Page Not Found
    </mat-card-title>
  </mat-card>
</div>
